import { Typography } from '@/app/common';
import { HeadlineData } from './headline.types';
import { cn, getBackgroundClass } from '@workspace/lib';
import { getTextAlignClasses, processHeading } from '@workspace/lib/heading-utils';

export function Headline({ shortSummary, title, backgroundColor, headingAlignment }: HeadlineData) {
  const { text: resolvedHeadingText } = processHeading(title);

  const textAlignClasses = getTextAlignClasses(headingAlignment);
  const backgroundClass = getBackgroundClass(backgroundColor);
  const containerAlignClasses =
    headingAlignment === 'center' ? 'mx-auto' : headingAlignment === 'right' ? 'ml-auto' : '';
  const summaryAlignMargin = headingAlignment === 'center' ? 'mx-auto' : headingAlignment === 'right' ? 'ml-auto' : '';
  return (
    <div className={backgroundClass}>
      <section className={cn('wrapper min-h-54 md:min-h-63 md:py-lg py-lg px-md md:px-4xl')}>
        <div
          className={cn(
            'max-w-81.75 md:max-w-243.25 flex flex-col gap-sm md:gap-xs py-3.5 md:py-9',
            containerAlignClasses,
          )}
        >
          {resolvedHeadingText && (
            <Typography variant="h1" className={cn(textAlignClasses)} styleVariant="h1">
              {resolvedHeadingText}
            </Typography>
          )}
          {shortSummary && (
            <Typography
              variant="bodyMd"
              className={cn(
                'max-w-76.5 md:max-w-146.5 text-sm md:text-base text-secondary-500',
                textAlignClasses,
                summaryAlignMargin,
              )}
            >
              {shortSummary}
            </Typography>
          )}
        </div>
      </section>
    </div>
  );
}
